import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=20ac8b44&scoped=true"
import script from "./Orcamentos.vue?vue&type=script&lang=js"
export * from "./Orcamentos.vue?vue&type=script&lang=js"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=20ac8b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac8b44",
  null
  
)

export default component.exports